import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

export function registerStoreSystemComponent(Vue) {
  const requireComponent = require.context('.', true, /[\w-]+\.vue$/);

  return requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName);
    const componentName = upperFirst(camelCase(fileName.replace(/^\..*\//, '').replace(/\.\w+$/, '')));

    console.log(`Loading system component "${componentName}"`); // eslint-disable-line no-console

    Vue.component(componentName, componentConfig.default || componentConfig);
  });
}
